export const TIMER = 5000

export const DIVIDER_PREVIEW = 1.375

export const DIVIDER_PREVIEW_XXL = 1.35

export const FULL_VIEWPORT = 100

export const BANNER_HEIGHT_OFFSET_IN_PIXELS = 100
